(function (window, document, $) {
  'use strict';
  var jBox = window.jBox;
  var tscUtil = window.tscUtil || {};

$(document).on('click', 'a', function (e) {
  if (e.currentTarget.target === '_blank' && !e.currentTarget.rel) {
    e.currentTarget.rel = 'noopener noreferrer';
  }
});

var setPassThroughLinks = function () {
  var pattern = /\?(.+)/;
  var match = window.location.search.match(pattern);

  if (!match) {
    return;
  }

  $('span.passThroughLink, img.passThroughLink').parent('a').each(function (i, el) {
    var hrefPattern = /^([^?#]*)((?:\?[^#]*)?)((?:#.*)?)$/;
    var hrefMatch = el.href.match(hrefPattern);
    var passThrough = (hrefMatch[2] ? '&' : '?') + match[1];

    el.href = [hrefMatch[1], hrefMatch[2], passThrough, hrefMatch[3]].join('');
  });
};

var setupGlobalNav = function () {
  var jQdocument = $(document);
  var mouseenterDelay = 300;
  var mouseleaveDelay = 500;
  var menuHoverTimeoutDataKey = 'timeoutReference';
  var jQbody;
  var jQtscHeader;
  var jQmenuItems;
  var jQmenuTriggers;
  var jQmobileMenuTriggers;
  var jQmobileMenuTriggerWrapper;
  var jQsearchForms;
  var jQsearchSubmits;
  var isInMobileMode;

  var initalizeJQelements = function () {
    if (jQbody) { return; }

    jQbody = $('body');
    jQtscHeader = $('header.tsc-header');
    jQmenuItems = jQtscHeader.find('li.level-1');
    jQmenuTriggers = jQmenuItems.children('a');
    jQmobileMenuTriggers = jQtscHeader.find('button.menu-trigger');
    jQmobileMenuTriggerWrapper = jQmobileMenuTriggers.parent('.menu-trigger-wrapper');
    jQsearchForms = jQtscHeader.find('form.search');
    jQsearchSubmits = jQsearchForms.find('button.search-submit');
    isInMobileMode = function () {
      return jQmobileMenuTriggerWrapper.css('position') === 'absolute';
    };
  };

  var initializeNav = function () {
    initalizeJQelements();

    var menuActiveIndicatorClass = 'menu-active';
    var submenuActiveClass = 'active';
    var menuDeactivatedClass = 'deactivated';
    var menuInitializedClass = 'menu-initialized';
    var noSubMenusClass = 'no-submenu';
    var menuHeightDataKey = 'menuHeight';
    var menuHoverTimeoutDataKey = 'timeoutReference';

    var menuInitialized = false;
    var jQnavWrapper = jQtscHeader.children('.global-nav-wrapper');
    var jQnav = jQnavWrapper.children('.global-nav');
    var jQmenu = jQnav.children();
    var jQsubmenuWrappers = jQmenuItems.children('.detailed-menu-wrapper, .simple-menu-wrapper');
    var jQsubmenus = jQsubmenuWrappers.children();

    var setupNoSubmenus = function () {
      if (menuInitialized || mobileMenuInitialized) {
        return;
      }
      jQmenuItems.each(function (i, el) {
        var $el = $(el);
        $el.toggleClass(noSubMenusClass, $el.find(jQsubmenuWrappers).length === 0);
      });
    };
    var initializeDropdownMenus = function () {
      jQsubmenuWrappers.each(function () {
        var jQele = $(this),
            jQsubmenu = jQele.children(),
            height = jQele.height();
        jQele.height(height); // auto height to explicit height
        jQsubmenu.data(menuHeightDataKey, height);
      });
      jQbody.addClass(menuInitializedClass);
      setupNoSubmenus();
      menuInitialized = true;
    };
    var isDropdownMenuTransitioning = function (jQsubmenu) {
      var height = jQsubmenu.height();
      return 0 < height && height < jQsubmenu.data(menuHeightDataKey);
    };
    var activateMenu = function (jQlistItem) {
      deactivateMobileMenu();
      jQbody.addClass(menuActiveIndicatorClass);
      jQlistItem.removeClass(menuDeactivatedClass).addClass(submenuActiveClass).siblings().addClass(menuDeactivatedClass).removeClass(submenuActiveClass);
    };
    var inactivateMenu = function (jQlistItem) {
      if (jQlistItem.hasClass(submenuActiveClass)) {
        jQlistItem.removeClass(submenuActiveClass);
        if (jQmenuItems.filter(submenuActiveClass).length === 0) {
          jQbody.removeClass(menuActiveIndicatorClass);
        }
      }
    };
    var inactivateDropdownMenus = function () {
      jQbody.removeClass(menuActiveIndicatorClass);
      jQmenuItems.removeClass(submenuActiveClass);
    };

    // mobile menu stuff
    var mobileMenuInitialized = false;
    var hasProvincialMobileMenu = false;
    var hasProvincialMenuClass = 'has-submenu';
    var mobileMenuActiveIndicatorClass = 'mobile-menu-active';
    var mobileMenuOpeningClass = 'mobile-menu-opening';
    var mobileMenuDeactivatedClass = 'mobile-menu-deactivated';
    var mobileActivateMenuClasses = [mobileMenuActiveIndicatorClass, mobileMenuOpeningClass].join(' ');
    var activatedMobileMenuClass = 'activated-mobile-menu';
    var deactivatedMobileMenuClass = 'inactive-mobile-menu';
    var mobileMenuActiveLevelClasses = ['level-1-active', 'level-2-active', 'level-3-active'];
    var mobileLevel1ActiveClass = 'level-1-active';
    var mobileLevel2ActiveClass = 'level-2-active';
    var mobileLevel3ActiveClass = 'level-3-active';

    var isMobileMenuTransitioning = function () {
      var navWrapperLeft = -1 * parseFloat(jQnavWrapper.css('left'));
      var navWrapperWidth = jQnavWrapper.width();
      var navWrapperPercent = Math.round(100 * (navWrapperLeft / navWrapperWidth) % 100);
      var navLeft = -1 * parseFloat(jQnav.css('left'));
      var navWidth = jQnav.width();
      var navPercent = Math.round(100 * (navLeft / navWidth) % 100);
      return  (0 < navWrapperPercent && navWrapperPercent < 100) || (0 < navPercent && navPercent < 100);
    };
    var initializeMobilemenu = function () {
      var backToLevel1Handler = function (e) {
        e.preventDefault();
        activateMobileMenuLevel(1);
      };
      jQsubmenuWrappers.each(function (i, el) {
        var jQwrapper = $(el);
        var jQsubmenu = jQwrapper.children();
        var jQlink = jQwrapper.prev();
        var jQnewListItem = $('<li>', { 'class': 'mobile-menu-back' });
        var jQmenuBack = $('<a>', { href: jQlink.attr('href') }).text(jQlink.text());
        jQsubmenu.prepend(jQnewListItem.append(jQmenuBack));
        jQmenuBack.click(backToLevel1Handler);
      });
      jQsubmenus.find('.submenu-wrapper').each(function (i, el) { // there can be only one
        var jQsubmenuWrapper = $(el);
        var jQlink = jQsubmenuWrapper.parent().find('.product, > a');
        var jQnewListItem = $('<li>', { 'class': 'mobile-menu-back' });
        var jQmenuBack = $('<a>', { href: jQlink.attr('href') }).text(jQlink.find('dt').text() || jQlink.text());
        jQsubmenuWrapper.children().prepend(jQnewListItem.append(jQmenuBack));
        jQsubmenuWrapper.parent().addClass(hasProvincialMenuClass);
        jQmenuBack.click(function (e) {
          e.preventDefault();
          activateMobileMenuLevel(2, jQmenuBack.parents('.level-1'));
        });
        jQlink.click(function (e) {
          e.preventDefault();
          activateMobileMenuLevel(3);
        });
        hasProvincialMobileMenu = true;
      });
      setupNoSubmenus();
      mobileMenuInitialized = true;
    };
    var activateMobileMenuLevel = function (level, jQlevel1ListItem) {
      if (!isMobileMenuTransitioning()) {
        jQbody.removeClass(mobileMenuOpeningClass);
        $.each(mobileMenuActiveLevelClasses, function (i, val) {
          jQbody.toggleClass(val, level === i + 1);
        });
        if (level === 2) {
          jQlevel1ListItem.removeClass(deactivatedMobileMenuClass).addClass(activatedMobileMenuClass).
            siblings().addClass(deactivatedMobileMenuClass).removeClass(activatedMobileMenuClass);
        } else {
          jQmenu.find('.' + activatedMobileMenuClass).removeClass(activatedMobileMenuClass);
        }
      }
    };
    var deactivateMobileMenu = function () {
      jQbody.removeClass(mobileActivateMenuClasses);
      jQmenu.find('.' + activatedMobileMenuClass).removeClass(activatedMobileMenuClass);
    };
    var deactivateMobileMenuImmediately = function () {
      jQbody.addClass(mobileMenuDeactivatedClass);
      deactivateMobileMenu();
    };

    $(jQbody.data('menu-nav')).addClass('nav-active');
    $(jQbody.data('submenu-nav')).addClass('nav-active').append(jQnav.data('section-menu'));

    jQdocument.off('.initnav').on('click', 'li.level-1 > a', function (e) {
      var jQlistItem = $(e.currentTarget).parent();
      if (jQlistItem.hasClass(noSubMenusClass)) {
        return;
      }
      e.preventDefault();
      e.stopImmediatePropagation();
      if (isInMobileMode()) {
        activateMobileMenuLevel(2, jQlistItem);
      } else {
        if (!menuInitialized) { initializeDropdownMenus(); }

        if (!isDropdownMenuTransitioning(jQlistItem.find(jQsubmenus))) {
          if (jQlistItem.hasClass(submenuActiveClass)) {
            inactivateMenu(jQlistItem);
          } else {
            activateMenu(jQlistItem);
          }
        }
      }

    }).on('mouseenter', 'li.level-1', function (e) {
      var jQel;
      if (isInMobileMode()) { return; }
      if (!menuInitialized) { initializeDropdownMenus(); }
      jQel = $(e.currentTarget);
      clearTimeout(jQel.data(menuHoverTimeoutDataKey));
      if (isDropdownMenuTransitioning(jQel.find(jQsubmenus))) {
        activateMenu(jQel);
      } else {
        jQel.data(menuHoverTimeoutDataKey, setTimeout(function () {
          activateMenu(jQel);
        }, jQel.hasClass(noSubMenusClass) ? 0 : mouseenterDelay));
      }

    }).on('mouseleave', 'li.level-1', function (e) {
      var jQel;
      if (isInMobileMode()) { return; }
      jQel = $(e.currentTarget);
      clearTimeout(jQel.data(menuHoverTimeoutDataKey));
      jQel.data(menuHoverTimeoutDataKey, setTimeout(function () {
        inactivateMenu(jQel);
      }, jQel.hasClass(noSubMenusClass) ? 0 : mouseleaveDelay));

    }).on('click', 'button.menu-trigger', function () {
      if (!isInMobileMode()) { return; }
      if (!mobileMenuInitialized) { initializeMobilemenu(); }
      if (jQbody.hasClass(mobileMenuActiveIndicatorClass)) {
        deactivateMobileMenu();
      } else {
        activateMobileMenuLevel(hasProvincialMobileMenu ? 3 : 1);
        jQbody.addClass(mobileActivateMenuClasses).removeClass(mobileMenuDeactivatedClass);
      }
      inactivateDropdownMenus();

    }).on('focusin', function (e) {
      if (jQbody.hasClass(mobileMenuActiveIndicatorClass) &&
              document !== e.target &&
              jQnavWrapper[0] !== e.target && jQnavWrapper.has(e.target).length === 0 &&
              !jQmobileMenuTriggers.is(e.target) && jQmobileMenuTriggers.has(e.target).length === 0) {
        deactivateMobileMenuImmediately();
      }

    }).on('click', function (e) {
      var jQclickedElement = $(e.target),
        menuActive = jQbody.hasClass(menuActiveIndicatorClass),
        mobileMenuActive = jQbody.hasClass(mobileMenuActiveIndicatorClass),
        clickedjQnav,
        clickedjQnavWrapper,
        clickedjQmobileMenuTrigger;

      if (menuActive) {
        clickedjQnav = jQclickedElement.closest(jQnav).length > 0;

        if (!clickedjQnav) {
          inactivateDropdownMenus();
        }
      }

      if (mobileMenuActive) {
        clickedjQnavWrapper = jQclickedElement.closest(jQnavWrapper).length > 0;
        clickedjQmobileMenuTrigger = jQclickedElement.closest(jQmobileMenuTriggers).length > 0;

        if (!clickedjQnavWrapper && !clickedjQmobileMenuTrigger) {
          deactivateMobileMenu();
        }
      }
    });
  };

  var intializeSearch = function () {
    initalizeJQelements();

    var searchActiveClass = 'search-active';
    var searchSliderInitialized = false;

    var activateMenuSlideFirstRun = function () {
      jQmenuTriggers.each(function (i, el) {
        var jQel = $(el),
            width = jQel.width();
        jQel.width(width); // auto width to explicit width
      });
      searchSliderInitialized = true;
    };
    var undoSearchSlideSetup = function () {
      if (searchSliderInitialized && isInMobileMode()) {
        jQmenuTriggers.css('width', '');
        searchSliderInitialized = false;
      }
    };
    var activateSearch = function (jQsearchInput) {
      if (!isInMobileMode() && !searchSliderInitialized) {
        activateMenuSlideFirstRun();
      }
      jQbody.addClass(searchActiveClass);
      jQsearchInput.focus();
    };
    var inactivateSearch = function () {
      jQbody.removeClass(searchActiveClass);
    };


    jQdocument.off('.initsearch').on('click', 'button.search-submit', function (e) {
      var jQsearchInput = $(e.currentTarget).prev();
      if (jQsearchInput.css('visibility') === 'hidden') {
        e.preventDefault();
        activateSearch(jQsearchInput);
      } else if (!jQsearchInput.val()) {
        e.preventDefault();
      }
    });

    jQmobileMenuTriggers.on('click', undoSearchSlideSetup);

    jQdocument.on('click.deactivatesearch', function (e) {
      if (!jQbody.hasClass(searchActiveClass)) {
        return;
      }

      var searchWrapperSelector = '.search-input-wrapper';
      var swiftSearchModalCloseSelector = '.st-ui-close-button';
      var swiftSearchModalSelector = '.st-ui-container-overlay';
      var jQclickedElement = $(e.target);
      var clickedSearchWrapper = jQclickedElement.closest(searchWrapperSelector).length > 0;
      var clickedSearchModalClose = jQclickedElement.closest(swiftSearchModalCloseSelector).length > 0;
      var clickedSearchModal = !clickedSearchModalClose && jQclickedElement.closest(swiftSearchModalSelector).length > 0;

      if (!clickedSearchWrapper && !clickedSearchModal) {
        inactivateSearch();
      }
    });
  };

  jQdocument.on('click.initnav', 'li.level-1 > a', function (e) {
    var jQel = $(e.currentTarget);
    clearTimeout(jQel.parent().data(menuHoverTimeoutDataKey));
    e.preventDefault();
    initializeNav();
    jQel.trigger(e);

  }).on('mouseenter.initnav', 'li.level-1', function (e) {
    var jQel = $(e.currentTarget);
    jQel.data(menuHoverTimeoutDataKey, setTimeout(function () {
      initializeNav();
      jQel.children('a').trigger('click');
    }, mouseenterDelay));

  }).on('mouseleave.initnav', 'li.level-1', function (e) {
    clearTimeout($(e.currentTarget).data(menuHoverTimeoutDataKey));

  }).on('click.initnav', 'button.menu-trigger', function (e) {
    initializeNav();
    $(e.currentTarget).trigger(e);

  }).on('click.initsearch', 'button.search-submit', function (e) {
    intializeSearch();
    $(e.target).trigger(e);
  });
};

var setupStickyComponents = function () {

  var $window = $(window);
  var $contentWrapper = $('.content-wrapper');
  var $navBar = $('div.navigation-bar-wrapper');
  var throttle = window.tscUtil.throttle;
  var prevNavBarStickyness = false;
  var navBarOffsetTopOrig;
  var $stickyBar;

  if ($navBar.length) {
    navBarOffsetTopOrig = $navBar.offset().top;
    $stickyBar = $navBar.next('.sticky-nav-bar-spacer');

    if (!$stickyBar.length) {
      $stickyBar = $('<div>').addClass('sticky-nav-bar-spacer').insertAfter($navBar);
    }

    $navBar = $navBar.add($stickyBar);
  }

  var positionNavBar = function (windowScrollTop) {
    if (!$navBar.length) {
      return;
    }

    var sticky = windowScrollTop > navBarOffsetTopOrig;
    if (prevNavBarStickyness !== sticky) {
      prevNavBarStickyness = sticky;
      $navBar.toggleClass('sticky', sticky);
    }
  };


  var $stickyElement = $('.sticky-aside');
  var mainPanel = $('#cart-main-panel');
  var summaryPanel = $('#cart-summary-panel');
  var elOffsetTopOrig;
  var $stickyPlaceholder;

  if ($stickyElement.length) {
    elOffsetTopOrig = $stickyElement.offset().top;
    $stickyPlaceholder = $('<div>').addClass('sticky-placeholder').insertAfter($stickyElement);
  }

  var positionSticky = function (windowScrollTop) {
    if (!$stickyElement.length) {
      return;
    }

    var mobile =  mainPanel.width() === summaryPanel.width();
    var sticky = windowScrollTop > elOffsetTopOrig;

    if (sticky && !mobile) {
      var offset = $stickyPlaceholder.offset();
      var width = $stickyPlaceholder.width();

      var contentBottom = $contentWrapper.offset().top + $contentWrapper.height();
      var stickyHeight = $stickyElement.outerHeight();
      var pastContent = windowScrollTop + stickyHeight > contentBottom;


      if (pastContent) {
        $stickyPlaceholder.height(0);
        $stickyElement.css({
          position: 'relative',
          top: contentBottom - elOffsetTopOrig - stickyHeight,
          left: '',
          width: ''
        });
      } else {
        $stickyPlaceholder.height($stickyElement.height());
        $stickyElement.width($stickyPlaceholder.width());
        $stickyElement.css({
          position: 'fixed',
          top: 0,
          left: offset.left + 'px',
          width: width + 'px'
        });
      }
    } else {
      $stickyPlaceholder.height(0);
      $stickyElement.css({
        position: 'relative',
        top: '',
        left: '',
        width: ''
      });
    }
  };

  positionSticky($window.scrollTop());
  $(document).on('scroll', throttle(function () {
    var scrollTop = $window.scrollTop();
    positionNavBar(scrollTop);
    positionSticky(scrollTop);
  }, 15));
  $window.on('resize', throttle(function () {
    positionSticky($window.scrollTop());
  }, 15));

};

var setupFullWidthHero = function () {
    $('body[class*=col-] .hero').each(function () {
        var $this, $window, $parent, resize;
        $this = $(this);
        $window = $(window);
        $parent = $this.parent().css({overflow: 'visible', minHeight: 0});
        resize = function () {
            $this.css({left: -1 * $parent.offset().left + 'px'}).
                width($window.width()).addClass('full-width');
        };
        $window.on('resize', resize);
        resize();
    });
};

var setupTablesorter = function () {
  if (!$.fn.tablesorter) {
    return;
  }

  $('table[data-tablesorter]').each(function (i, el) {
    var $table = $(el);
    var data = $table.data('tablesorter');
    var match = data.match(/^(\d)-(asc|desc)$/);
    var column = match ? parseInt(match[1], 10) : 0;
    var direction = match && match[2] === 'desc' ? 1 : 0;

    $table.tablesorter({
      widgets: ['zebra'],
      sortList: [[column, direction]]
    });
  });
};

var setupJBox = function () {

  if (!$.isFunction(jBox)) {
    return;
  }

  // Store active tooltip / state management
  var activeTooltip = null;

  // Define each tooltip
  $('.jbox-tooltip').each(function (i, el) {
    var $tooltipTrigger = $(el);
    var contentSelector = $tooltipTrigger.data('jbox-content-selector');
    if (!contentSelector) {
      $tooltipTrigger.addClass('jbox-error');
    } else {
      var $content = $(contentSelector);
      if (!$content.length || $content.is(':empty')) {
        $tooltipTrigger.addClass('jbox-error');
      } else {
        new jBox('Tooltip', {
            id: $tooltipTrigger.attr('id'),
            attach: '#' + $tooltipTrigger.attr('id'),
            title: '',
            content: $content.html(),
            trigger: 'click',
            closeButton: true,
            maxWidth: 300,
            position: {
              y: 'top',
              x: 'center'
            },
            onOpen: function () {
              if (activeTooltip) {
                activeTooltip.close();
              }
              activeTooltip = this;
            },
            onClose: function () {
              // Timing of opening and closing when another
              // tooltip is open requires additional check
              if (this.id === activeTooltip.id) {
                activeTooltip = null;
              }
            }
        });
      }
    }
  });

  // Close tooltip on other UI/page clicks, i.e. tab changes
  $(document).click(function (event) {
    var $target = $(event.target);
    var withinTooltip = $target.closest('.jbox-tooltip, .jBox-wrapper').length;
    var hasError = $target.hasClass('jbox-error');
    if (activeTooltip && (!withinTooltip || hasError)) {
      activeTooltip.close();
    }
  });

  // Close tooltip on resize
  $(window).resize(function () {
    if (activeTooltip !== null) {
      activeTooltip.close();
    }
  });
};

var setupEnthinkTabs = function () {

  if (!window.Enthink || !window.Enthink.Tabs || !$.isFunction(window.Enthink.Tabs.InitTabs)) {
    return;
  }

  var urlParams = $.isFunction(tscUtil.getUrlParams) ? tscUtil.getUrlParams() : {};
  var tscTabConditions = window.tscTabConditions || {};

  // "Tab Item" Content Class
  var tabItemConfig = {
    paneContentSelector: '.tsc-big-tabs-pane',
    tabTextSelector: '.tab-title',
    tabsID: 'tsc-big-tabs', // One set per page
    tabsClass: 'tsc-big-tabs',
    tabClass: 'tab',
    tabActivationData: urlParams,
    tabActivationConditions: tscTabConditions,
    smartEdit: $('body').hasClass('smartedit')
  };
  window.Enthink.Tabs.InitTabs(tabItemConfig);
};

var setupProductQuiz = function () {

  $('.quiz-trigger').click(function (e) {
    e.preventDefault();

    var $this = $(this);
    var $quiz = $('#quiz-' + $this.data('quiz-id'));

    // Use first .quiz if an ID is not provided via data-quiz-id="X"
    if (!$quiz.length) {
      $quiz = $('.quiz').first();
    }

    if ($quiz.length < 1) {
      return;
    }

    if (!$this.hasClass('active')) { // We don't toggle() the quiz, only show it
      var $firstQuestion = $quiz.children('fieldset').first();

      $this.addClass('active');
      $quiz.show();
      $firstQuestion.toggleClass('active sr-only');
      $firstQuestion.find('input').first().focus();
    }

    var smoothScroll = window.smoothScroll || {};
    if (smoothScroll.scrollTo) {
      smoothScroll.scrollTo($quiz);
    } else {
      $quiz[0].scrollIntoView();
    }
  });

  // "Quiz" Content Class
  $('.quiz').each(function (i, quiz) {
    var $quiz = $(quiz);
    var $counter = $quiz.find('.counter');

    $quiz.find('.next, .prev').click(function (e) {
      e.preventDefault();

      var $btn = $(this);
      var $parentFieldset = $btn.closest('fieldset');
      var $status = $parentFieldset.find('.validation-message');
      var errorText = $status.data('error-text');

      if ($btn.hasClass('next') && !$parentFieldset.find('input:checked').length) { // Nothing clicked

        $status.text(errorText);
        $parentFieldset.find('input').first().attr('aria-invalid', 'true').focus();

      } else {

        $status.text('');
        $parentFieldset.find('input[aria-invalid]').removeAttr('aria-invalid');
        $parentFieldset.toggleClass('active sr-only'); // Hide self

        if ($btn.is(':submit')) { // Allow submission

          // Force reset state if Back is pressed after submission (Safari)
          $counter.text('1');
          $('.quiz-trigger.active').removeClass('active');
          $quiz.hide().submit();

        } else { // Next question

          var offset = $btn.hasClass('prev') ? -1 : 1;
          var newIndex = $parentFieldset.index('fieldset') + offset;

          $quiz.children('fieldset').eq(newIndex)
            .toggleClass('active sr-only')
            .find('input')
            .first()
            .focus();
          $counter.text(newIndex + 1); // Human readable

          var smoothScroll = window.smoothScroll || {};
          if (smoothScroll.scrollTo) {
            smoothScroll.scrollTo($quiz);
          } else {
            $quiz[0].scrollIntoView();
          }
        }
      }
    });
  });
};

// CMS Keyword-driven Personalization
// - Show/Hide content based on set of Conditions
// - All/any/none Conditions can be met
// - Conditions match CMS keywords on all/any/none
var setupPersonalization = function () {

  var tscPersonalizationWrappers = window.tscPersonalizationWrappers || {};
  var urlParams = $.isFunction(tscUtil.getUrlParams) ? tscUtil.getUrlParams() : {}; // Using query string for now

  /* Helper functions */

  // Run appropriate checks for each set of conditions
  var checkCondition = function (conditions) {
    switch (conditions.constraint) {
      case 'all':
        return matchAllRules(conditions.taxonomy, urlParams);
      case 'none':
        return matchNoRules(conditions.taxonomy, urlParams);
      default:
        return matchAtLeastOneRule(conditions.taxonomy, urlParams);
    }
  };

  // Check an individual rule against data
  var checkRule = function (data) {
    return function (rule) {
      var entry = data[rule.key];
      // Data entries can be a string or array of strings
      return Array.isArray(entry) ? entry.indexOf(rule.val) > -1 : entry === rule.val;
    };
  };

  // Check all 'rule' pairs are in 'data'
  var matchAllRules = function (rules, data) {
    return rules.every(checkRule(data));
  };

  // Check at least one 'rule' pairs are in 'data'
  var matchAtLeastOneRule = function (rules, data) {
    // No rules and no data considered a match
    if (data.length < 1) {
      return rules.length < 1;
    }
    return rules.some(checkRule(data));
  };

  // Check no 'rule' pairs are in 'data'
  var matchNoRules = function (rules, data) {
    if (data.length < 1) {
      return true; // No rules will match if data is empty
    }
    return !rules.some(checkRule(data));
  };


  /* "Personalization Wrappers" Content Class Setup */

  var anyMatch = false;
  var hideOnAnyMatchArr = [];
  var $wrappers = $('.personalization-wrapper');

  $wrappers.each(function (i, el) {

    var $wrapper = $(el); // Each wrapper hidden by default

    // Each wrapper instance outputs the necessary object, even with no conditions
    var conditionMatching = tscPersonalizationWrappers[$wrapper.data('id')].matching;
    var conditions = tscPersonalizationWrappers[$wrapper.data('id')].conditions;
    var showContent = conditions.length < 1;  // No constraints assigned, show by default.
    var hideMeIfOthersMatch = $wrapper.data('hide'); // Allow wrapper to hide itself if any others match

    if (hideMeIfOthersMatch) {
      hideOnAnyMatchArr.push($wrapper);
    }

    if (!showContent) {
      switch (conditionMatching) {
        case 'all':
          showContent = conditions.every(checkCondition);
          break;
        case 'none':
          showContent = !conditions.some(checkCondition);
          break;
        default:
          showContent = conditions.some(checkCondition);
      }
    }

    if (showContent) { // Only turn on, not off for CMS
      $wrapper.show();

      if (!hideMeIfOthersMatch) { // Track others which match
        anyMatch = true;
      }
    }
  });

  if (anyMatch && hideOnAnyMatchArr.length) {
    $.each(hideOnAnyMatchArr, function (i, $wrapper) {
      $wrapper.hide();
    });
  }
};

/* --- Document Ready and Window Load actions --- */

$(document).ready(function () {
    setPassThroughLinks();
    setupGlobalNav();
    setupStickyComponents();
    setupFullWidthHero();
    setupTablesorter();
    setupJBox();
    setupProductQuiz();
    setupPersonalization();
    setupEnthinkTabs();
    $('body').removeClass('no-js').addClass('js'); // Allows for controlled styles if JS is disabled or broken.
});

}(window, document, jQuery));
